import { Component, inject, OnInit } from '@angular/core';
import { QuestionItem } from '../../models/question-item.model';
import { ButtonType } from '../../common-components/fancy-button/button-type.enum';
import { DistributionCircleComponent } from '../../common-components/distribution-circle/distribution-circle.component';
import { HeaderComponent } from '../../common-components/header/header.component';
import { MainCardComponent } from '../../common-components/main-card/main-card.component';
import { NavigationBoxComponent } from '../../common-components/navigation-box/navigation-box.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Audit } from '../../models/audit.model';
import { switchMap, tap } from 'rxjs';
import { AssignmentService } from '../../services/assignment.service';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-audit-summary-page',
  standalone: true,
  imports: [
    DistributionCircleComponent,
    HeaderComponent,
    MainCardComponent,
    NavigationBoxComponent,
    TranslocoDirective
  ],
  templateUrl: './audit-summary-page.component.html',
  styleUrl: './audit-summary-page.component.scss'
})
export class AuditSummaryPageComponent implements OnInit {
  protected questionList: QuestionItem[] = [];
  protected audit: Audit = new Audit();

  private router = inject(Router);
  private location = inject(Location);
  private assignmentService = inject(AssignmentService);

  ngOnInit() {
    if ((this.location.getState() as object).hasOwnProperty('audit')) {
      this.audit = (this.location.getState() as any).audit;
    }
    this.assignmentService.getTaskLayoutId(this.audit.id).pipe(
      switchMap(layout => this.assignmentService.getTaskList(layout)),
      tap(taskList => this.questionList = taskList)
    ).subscribe()
  }

  protected navigate(): void {
    this.assignmentService.getTaskLayoutId(this.audit.id).pipe(
      tap((layoutId) => this.router.navigate(['audit', layoutId]).then())
    ).subscribe()
  }
}
